import { teslaApi } from "./teslaApi";

export interface IndicativeEnergyPrice {
  year: number;
  startDate: string;
  submarket: string;
  wholesaleI0: number | null;
  wholesaleI5: number | null;
  wholesaleI1: number | null;
  retailerI0: number | null;
  retailerI5: number | null;
  retailerI1: number | null;
}

interface LatestIndicativeEnergyPricesResponse {
  latestIndicativo: IndicativeEnergyPrice[];
}

export const getLatestIndicativeEnergyPrices = async (): Promise<
  IndicativeEnergyPrice[]
> => {
  const response = await teslaApi.get<LatestIndicativeEnergyPricesResponse>(
    "energy-price/latest/public"
  );

  return response.data?.latestIndicativo ?? [];
};
